const Base: React.FC = () => {
  return (
    <svg version="1.1" id="Logo" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
      viewBox="0 0 238.6 242.4" >
      <g>
        <path className="st0" d="M130.4,68.4L130.4,68.4l-46.6,0V174h20.8v-39.7h25.9v-0.2c0.6,0.2,1.3,0.2,2,0.2c14,0,28.1-14.8,27.7-32
		C159.9,85.9,146.3,67.9,130.4,68.4z M140.2,100.7c0.1,3.8-2.9,12.7-7.6,14.9c-1.3,0.6-2.1,0.7-2.1,0.7h-25.9v-31h25.9
		c0,0,0.7,0.3,1.1,0.5C139.1,90.1,140.1,96.7,140.2,100.7z"/>
      </g>
    </svg>

  )
}

export default Base